/**
 * Shared framer-motion variants. Import these from route components and
 * UI primitives to keep page transitions and stagger behavior consistent.
 *
 * Usage:
 *   <motion.div variants={fadeUp} initial="hidden" animate="show" />
 *   <motion.ul variants={stagger} initial="hidden" animate="show" />
 */
import type { Variants, Transition } from 'framer-motion';

const ease: Transition['ease'] = [0.22, 1, 0.36, 1];

export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 12 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.32, ease },
  },
};

export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.24, ease } },
};

export const scaleIn: Variants = {
  hidden: { opacity: 0, scale: 0.96 },
  show: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.24, ease },
  },
};

export const stagger: Variants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.06,
      delayChildren: 0.04,
    },
  },
};

export const staggerFast: Variants = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.03 },
  },
};
